import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/brandonwu/Documents/PTS/Gatsby/Instana-1-Day-Partner-Workshop/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>
    Workshop Agenda <br />
  </span>;
;
export const _frontmatter = {};
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Instana Workshop Agenda:`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Introduction `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Product Overview & Architecture`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Product Demo   `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Instana Labs`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Environment Overview & Access Validation  `}</li>
          <li parentName="ul">{`Lab 1 - Agent Installation`}</li>
          <li parentName="ul">{`Lab 2 - Agent Troubleshooting`}</li>
          <li parentName="ul">{`Lab 3 - Agent Configuration`}</li>
          <li parentName="ul">{`Lab Summary`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Pricing and Deployment options`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Jeopardy - Round 1`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Lunch Break `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Pre-Sales & POC Overview`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Customer Success Stories`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Instana Labs`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Lab 4 - Robot Shop`}</li>
          <li parentName="ul">{`Lab 5 - Dynamic Focus Query`}</li>
          <li parentName="ul">{`Lab 6 - Application Perspective`}</li>
          <li parentName="ul">{`Lab Summary `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Jeopardy - Round 2`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Instana Competitive Advantage`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Instana Product Roadmap `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Instana Partner Technical Enablement Guide and Getting Assistance`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Instana Labs `}</p>
        <ul parentName="li">
          <li parentName="ul">{`Lab 7 - Service Mapping`}</li>
          <li parentName="ul">{`Lab 8 - Endpoint Mapping`}</li>
          <li parentName="ul">{`Lab 9 - Custom Events`}</li>
          <li parentName="ul">{`Lab Summary`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Final Jeopardy`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Open Discussion & Closing `}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      